import request from '@/utils/request'


// 查询产品规格组合选择列表
export function listGoodsSpecSame(query) {
  return request({
    url: '/user/goods-spec-same/list',
    method: 'get',
    params: query
  })
}

// 查询产品规格组合选择分页
export function pageGoodsSpecSame(query) {
  return request({
    url: '/user/goods-spec-same/page',
    method: 'get',
    params: query
  })
}

// 查询产品规格组合选择详细
export function getGoodsSpecSame(data) {
  return request({
    url: '/user/goods-spec-same/detail',
    method: 'get',
    params: data
  })
}

// 新增产品规格组合选择
export function addGoodsSpecSame(data) {
  return request({
    url: '/user/goods-spec-same/add',
    method: 'post',
    data: data
  })
}

// 修改产品规格组合选择
export function updateGoodsSpecSame(data) {
  return request({
    url: '/user/goods-spec-same/edit',
    method: 'post',
    data: data
  })
}

// 删除产品规格组合选择
export function delGoodsSpecSame(data) {
  return request({
    url: '/user/goods-spec-same/delete',
    method: 'post',
    data: data
  })
}
